// Asset's widget on the Dashboard (#253). Registered from `./index` at
// bootstrap; the Dashboard renders it by id and does not import Asset.
// Contract: `src/lib/dashboard-widgets.tsx`. Registrations only.
import { registerDashboardWidget } from '@/lib/dashboard-widgets'

registerDashboardWidget({
    id: 'asset.internal-information',
    load: () => import('./components/DashboardWidgets/InternalInformation'),
})
